import { render } from "./BookCard.vue?vue&type=template&id=7dba16d6&scoped=true"
import script from "./BookCard.vue?vue&type=script&lang=js"
export * from "./BookCard.vue?vue&type=script&lang=js"

import "./BookCard.vue?vue&type=style&index=0&id=7dba16d6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dba16d6"

export default script